import { useCallback, useMemo } from 'react';
import { IconButton } from 'src/components/Buttons';
import { vars } from 'src/core/themes';
import { ChevronLeftIcon, ChevronRightIcon } from 'src/svgs/Viagogo';
import { CatchUpModeSource } from 'src/WebApiController';

import { useCatchUpParams } from '../InventoryEventPage.hooks';

export function InventoryEventCatchUpPrevButton({
  source = CatchUpModeSource.InventoryEvents,
  numberOfEventOverride,
  onPrevClickOverride,
}: {
  source?: CatchUpModeSource;
  numberOfEventOverride?: number;
  onPrevClickOverride?: () => void;
}) {
  const { selectedIndex, numberOfEvents, onPrevClick } =
    useCatchUpParams(source);

  const onClick = useCallback(() => {
    if (onPrevClickOverride) {
      onPrevClickOverride();
    } else {
      onPrevClick();
    }
  }, [onPrevClick, onPrevClickOverride]);

  const prevButtonDisabled = useMemo(() => {
    if (selectedIndex == null) {
      return true;
    }
    const sanitzedNumberOfEvents = numberOfEventOverride ?? numberOfEvents;
    if (sanitzedNumberOfEvents == null) {
      return true;
    }
    return selectedIndex <= 0;
  }, [numberOfEventOverride, numberOfEvents, selectedIndex]);

  return (
    <IconButton
      icon={
        <ChevronLeftIcon
          fill={vars.color.textBrand}
          size={vars.iconSize.m}
          disabled={prevButtonDisabled}
          withHoverEffect
        />
      }
      style={{ padding: vars.spacing['lg'] }}
      disabled={prevButtonDisabled}
      onClick={onClick}
    />
  );
}

export function InventoryEventCatchUpNextButton({
  source = CatchUpModeSource.InventoryEvents,
  numberOfEventOverride,
  onNextClickOverride,
}: {
  source?: CatchUpModeSource;
  numberOfEventOverride?: number;
  onNextClickOverride?: () => void;
}) {
  const { selectedIndex, numberOfEvents, onNextClick } =
    useCatchUpParams(source);

  const onClick = useCallback(() => {
    if (onNextClickOverride) {
      onNextClickOverride();
    } else {
      onNextClick();
    }
  }, [onNextClick, onNextClickOverride]);

  const nextButtonDisabled = useMemo(() => {
    if (selectedIndex == null) {
      return true;
    }
    const sanitzedNumberOfEvents = numberOfEventOverride ?? numberOfEvents;
    if (sanitzedNumberOfEvents == null) {
      return true;
    }
    return selectedIndex >= sanitzedNumberOfEvents - 1;
  }, [numberOfEventOverride, numberOfEvents, selectedIndex]);

  return (
    <IconButton
      icon={
        <ChevronRightIcon
          fill={vars.color.textBrand}
          size={vars.iconSize.m}
          disabled={nextButtonDisabled}
          withHoverEffect
        />
      }
      style={{ padding: vars.spacing['lg'] }}
      disabled={nextButtonDisabled}
      onClick={onClick}
    />
  );
}
